import type { ReactNode } from "react";

export type StatCardProps = {
  /** Mono eyebrow label (e.g. "Gemiddeld"). */
  label: string;
  /** Big display value — "76" with an optional <small>/100</small>. */
  value: ReactNode;
  /** Muted sub-line; may carry a pass-tinted delta when tone="up". */
  sub?: ReactNode;
  tone?: "default" | "up";
  /** For `hidden lg:block` gating on mobile. */
  className?: string;
};

export function StatCard({ label, value, sub, tone = "default", className }: StatCardProps) {
  return (
    <div
      className={
        "rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--panel)] px-5 py-4 shadow-[var(--shadow)]" +
        (className ? ` ${className}` : "")
      }
    >
      <div className="font-mono-badge text-[10px] uppercase tracking-wider text-[var(--ink-faint)]">
        {label}
      </div>
      <div className="font-display font-semibold text-2xl sm:text-3xl leading-none mt-1.5">
        {value}
      </div>
      {sub ? (
        <div
          className={
            "text-xs mt-1.5 " +
            (tone === "up" ? "text-[var(--pass)]" : "text-[var(--ink-muted)]")
          }
        >
          {sub}
        </div>
      ) : null}
    </div>
  );
}
